import React, {useContext} from "react";
import "./MyProject.scss";
import {myProjects} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function MyProject() {
  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  const {isDark} = useContext(StyleContext);
  if (!myProjects.display) {
    return null;
  }
  return (
    <Fade left duration={1000} distance="20px">
      <div className="main" id="myProjects">
        <div>
          <h1 className="skills-heading fw-bold">{myProjects.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {myProjects.subtitle}
          </p>
          <Fade rights duration={1000} distance="20px">
            <div className="projects-container">
              {myProjects.projects.map((project, i) => {
                return (
                  <div
                    key={i}
                    className={
                      isDark
                        ? "dark-mode project-card project-card-dark"
                        : "project-card project-card-light"
                    }
                  >
                    {project.image ? (
                      <div className="project-image">
                        <img
                          src={project.image}
                          alt={project.projectName}
                          className="card-image"
                        ></img>
                        {/* <video autoPlay>
                          <source
                            src={project.image}
                            type="video/mp4"
                            className="card-image"
                          />
                        </video> */}
                      </div>
                    ) : null}
                    <div className="project-detail ">
                      <h5
                        className={
                          isDark ? "bg-light card-title " : "card-title"
                        }
                      >
                        {project.projectName}
                      </h5>
                      <p
                        className={
                          isDark
                            ? " bg-light  fw-bold  card-subtitle "
                            : "card-subtitle"
                        }
                      >
                        {project.projectDesc}
                      </p>
                      {project.footerLink ? (
                        <div className="project-card-footer">
                          {project.footerLink.map((link, i) => {
                            return (
                              <span
                                key={i}
                                className={
                                  isDark
                                    ? "dark-mode project-tag"
                                    : "project-tag"
                                }
                                onClick={() => openUrlInNewTab(link.url)}
                              >
                                {link.name}
                              </span>
                            );
                          })}
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              })}
            </div>
          </Fade>
        </div>
      </div>
    </Fade>
  );
}
